// content cards show/less
const cardsShow = document.querySelectorAll('.card_show'); 

cardsShow.forEach((card) => {
  const btn = card.querySelector('.card__show_more');
  const content = card.querySelector('.rte_show');
  const text_more = card.dataset.textMore;
  const text_less = card.dataset.textLess;

  btn.addEventListener("click", function () {
    if (content.classList.contains("expanded")) {
      content.classList.remove("expanded");
      content.classList.add("hidden");
      this.textContent = text_more;
    } else {
      content.classList.add("expanded");
      content.classList.remove("hidden");
      this.textContent = text_less;
    }
  });
})

// play/pause video (rich text block)
const rich_video_block = document.querySelector('.rich-text__video');

if (rich_video_block) {
  const rich_video = rich_video_block.querySelector('.rich-text__video video');
  const rich_block_play = document.querySelector('.play__video');
  const rich_block_pause = document.querySelector('.pause__video');
  const rich_button_play = rich_block_play.querySelector('.button');
  const rich_button_pause = rich_block_pause.querySelector('.button');
  const rich_video_text = document.querySelector('.play__video .button .button__text');

  rich_button_play.addEventListener('click', () => {
    richVideoPlay();
  })

  rich_block_pause.addEventListener('click', () => {
    richVideoPause();
  })

  function richVideoPlay() {
    rich_block_play.style.display = 'none';
    rich_block_pause.classList.add('show_pause');
    rich_video.play();
  }

  function richVideoPause() {
    rich_block_play.style.display = 'flex';
    rich_block_pause.classList.remove('show_pause');
    rich_video.pause();
  }

  function isVideoInViewport() {
    const rect = rich_video.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
  }

  window.addEventListener('scroll', () => {
    if (!isVideoInViewport() && !rich_video.paused) {
      richVideoPause();
    }
  });
}

// iubenda style customization
const observerIubenda = new MutationObserver(() => {
  if (document.querySelector('#iubenda-cs-banner .iubenda-cs-cwa-button')) {
    const style = document.createElement('style');
    style.innerHTML = `
      #iubenda-cs-banner .iubenda-cs-cwa-button,
      #iubenda-cs-banner .iubenda-cs-cwa-button:hover {
        box-shadow: none !important;
      }

      #iubenda-cs-banner .iubenda-cs-cwa-button {
        padding: 0 !important;
        text-align: left !important;
      }
    `;
    document.head.appendChild(style);
    observerIubenda.disconnect();
  }
});

observerIubenda.observe(document.body, { childList: true, subtree: true });